module.exports = __webpack_public_path__ + "static/img/card_bg.054257ce.png";